import CommonForm from "../../components/common/form";
import { registerFormControls } from "../../config";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { registerUser } from "../../store/features/auth/authThunks";
import { useDispatch } from "react-redux";
 import { toast } from "react-hot-toast";

const initialState = {
  name: "", 
  email: "",
  password: "",
};

function AuthRegister() {
  const [formData, setFormData] = useState(initialState);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  function onSubmit(event) {
    event.preventDefault();
    
    dispatch(registerUser(formData))
      .unwrap()
      .then((payload) => {
        console.log(payload,'payload');
        
        if (payload?.status === true) {
          toast.success(payload?.message || "Registration successful!");
          navigate("/auth/login");
        } else {
          toast.error(payload?.message || "Registration failed");
        }
      })
      .catch((err) => {
        // Handle different error formats
        const errorMessage = err?.message || 
                           err?.payload?.message || 
                           (Array.isArray(err) ? err.join(', ') : 
                           (typeof err === 'string' ? err : 'Registration failed'));
        
        toast.error(errorMessage);
      });
  }

  return (
    <div className="mx-auto w-full max-w-md space-y-6">
      <div className="text-center">
        <h1 className="text-3xl font-bold tracking-tight text-foreground">
          Create new account
        </h1>
        <p className="mt-2">
          Already have an account
          <Link
            className="font-medium ml-2 text-primary hover:underline"
            to="/auth/login"
          >
            Login
          </Link>
        </p>
      </div>
      
      <CommonForm
        formControls={registerFormControls}
        buttonText={"Sign Up"}
        formData={formData}
        setFormData={setFormData}
        onSubmit={onSubmit}
      />
    </div>
  );
}

export default AuthRegister;